
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExceptionService, PaginatedList, UtilsService } from '../../xform-compat';
import { ExchangeItem } from '../../shared/models';


/**
 * Data service to integrate exchanges
 */
@Injectable({
  providedIn: 'root'
})
export class ExchangeService {

  private url = '/api/rms/exchanges';

  constructor(
    private http: HttpClient,
    private utilsService: UtilsService,
    private exceptionService: ExceptionService
  ) { }

  /**
   * Gets the list of exchanges
   * @returns {Observable<PaginatedList<ExchangeItem>>}: Paginated list with the exchanges
   */
  public getRecords (params?: any): Observable<PaginatedList<ExchangeItem>> {
    const httpParams: HttpParams = this.utilsService.generateParams(params);
    return this.http.get(this.url, {params: httpParams}).pipe(catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

}
